import { render, staticRenderFns } from "./orderCuts.vue?vue&type=template&id=15ee44b6&scoped=true&"
import script from "./orderCuts.vue?vue&type=script&lang=js&"
export * from "./orderCuts.vue?vue&type=script&lang=js&"
import style0 from "./orderCuts.vue?vue&type=style&index=0&id=15ee44b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ee44b6",
  null
  
)

export default component.exports